import type { ReactNode } from "react";
import { actionBar, dock } from "@web/theme/theme";

export type DockProps = { children: ReactNode; className?: string };

/** Sticky surface pinned above the TabBar (a lead's action bar, the message composer). Put it last in the Page. */
export function Dock({ children, className = "" }: DockProps) {
  return <div className={`${dock} ${className}`.trim()}>{children}</div>;
}

export type ActionBarItem = { key: string; label: string; icon: ReactNode; onClick: () => void; disabled?: boolean; disabledReason?: string | null };

export type ActionBarProps = { items: readonly ActionBarItem[]; label?: string };

/** Docked row of icon + label buttons (SPEC §6.1 item 4: Text · Call · Email · Tour · Book · More). ≥44px each. */
export function ActionBar({ items, label = "Actions" }: ActionBarProps) {
  return (
    <Dock>
      <div role="toolbar" aria-label={label} className={actionBar.base}>
        {items.map((it) => (
          <button key={it.key} type="button" aria-label={it.label} title={it.disabledReason || undefined} disabled={it.disabled} onClick={it.onClick} className={actionBar.item}>
            {it.icon}
            <span className={actionBar.label}>{it.label}</span>
          </button>
        ))}
      </div>
    </Dock>
  );
}
